// extracted by mini-css-extract-plugin
export default {"color-hot-tamales":"#F9302D","colorHotTamales":"#F9302D","root":"cO1se","icon":"I175t"};